export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = process.env.REACT_APP_LOCAL_API_URL;
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
export const CDN_URL = process.env.REACT_APP_CDN_URL;

export const DISCORD_INVITE_LINK = process.env.REACT_APP_DISCORD_INVITE_LINK;
export const STEAM_WORKSHOP_LINK = process.env.REACT_APP_STEAM_WORKSHOP_LINK;
